import utils from "@/services/utils";
export default {
  getDescription() {
    return document.querySelector('meta[name="description"]').content;
  },
  setBrandPageDescription(brandName, descriptionHTML) {
    const plaintextDescription = utils.stripHtml(descriptionHTML);
    this.setDescription(`Buy ${brandName} Wholesale & retail on Bulletin.co. ${plaintextDescription}`);
  },
  setDescription(content) {
    document.querySelector('meta[name="description"]').content = content;
  },
  setTitle(title) {
    document.title = title;
  },
};
